module.exports = __webpack_public_path__ + "img/el_instituto.c74bb338.png";